module.exports = __webpack_public_path__ + "img/hiking_mount.96f3d060.jpg";